import React from "react";
import transparentLogo from "../assets/arkaariLogoBlack.png";

export const Logo = ({ className = "", size = "text-2xl" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <img
      src={transparentLogo}
      alt="Arkaari logo"
      className="block object-contain"
      style={{
        height: "35px",
        width: "auto",
        maxWidth: "180px",
      }}
    />
    <span className={`font-serif font-normal tracking-[0.35em] ${size}`} style={{ color: "#000000" , marginLeft: "-5px"}}>ARKAARI</span>
  </span>
);
